// extracted by mini-css-extract-plugin
export default {"task-item":"TaskListItems-module__task-item--iNNCi","task-items":"TaskListItems-module__task-items--UBJsK"};